import { useMutation, UseMutationOptions } from 'react-query';
import { AxiosError } from "axios";

import request from "common/request";

type InputUserDetailMutationVariable = {
  detailInfo:{
    name?:string;
    mobile?:string;
    postalNumber: string;
    defaultAddress: string;
    zoneCode:string;
    detailAddress?: string;
  }
};

export const usePostInputUserDetail = ( 
  options?: UseMutationOptions<any, AxiosError, InputUserDetailMutationVariable>
) => { 
  return useMutation<any, AxiosError, InputUserDetailMutationVariable>(
    async ({detailInfo}) => {
      try {
        const response = await request.post('/signup/detail',
        detailInfo
        );
        
        return response
      } catch(e){
        //@ts-ignore
        const result = e.response;
        if (result.status === 401) {
          window.location.href = '/onboarding/0/start'
        }
        return result
      }
    },
    {
      ...options
    }
  )
};

export default usePostInputUserDetail;